export const mapCsvRows = ({headers, rows, mapping}) =>
  rows.map((row) =>
    Object.fromEntries(
      headers
        .map((header, index) => [mapping[header], row[index]])
        .filter(([key]) => key)
    )
  );
